module.exports = __webpack_public_path__ + "img/send-verify-email.e7d085d5.svg";